import { render } from "./IncidentsPage.vue?vue&type=template&id=a43569e4&scoped=true&ts=true"
import script from "./IncidentsPage.vue?vue&type=script&lang=ts"
export * from "./IncidentsPage.vue?vue&type=script&lang=ts"

import "./IncidentsPage.vue?vue&type=style&index=0&id=a43569e4&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a43569e4"]])

export default __exports__